import styled from "styled-components";
import { devices } from "../../../utils/styled";
import { shadowCardStyle } from "../Cards/shadowCard.style";
import { overlayCardStyle } from "../Cards/overlayCard.style";
import { sectionStyle, titleStyle } from "../style";

export const RelatedNewsContainer = styled.section`
	${overlayCardStyle}
	${shadowCardStyle}
	${sectionStyle}

	> .rel-content__section__title {
		padding-bottom: 16px;
		${titleStyle}
	}

	> .rel-content__section__items {
		display: flex;
		gap: 45px;
		min-height: 644px;
		max-width: 1512px;
		margin-top: 32px;
		transform: translate(0, 50%);
		transition: transform 0.5s ease-out;
		/* ensure hover effect is not cut by overflow */
		padding: 0 16px 16px;

		@media ${devices.desktop} {
			padding-left: 0px;
		}

		@media ${devices.mobileAndTablet} {
			flex-direction: column;
		}

		&.animated {
			transform: translate(0, 0);
		}

		.rel-content__section__items__grid {
			flex: 1;
			gap: 45px;
			display: grid;
			grid-template-columns: 1fr 1fr;

			@media ${devices.mobile} {
				flex-direction: column;
				grid-template-columns: 1fr;
			}
		}
	}
`;
